import { apiGet, apiPost, apiPatch, apiDelete } from "./api.service";

export async function getContacts() {
    return apiGet('/users/contacts');
}

export async function getContact(contactEmail) {
    return apiGet(`/users/contacts/${contactEmail}`);
}

export async function addContact(newContact) {
    return apiPost('/users/contacts', newContact);
}

export async function deleteContact(contactEmail) {
    return apiDelete(`/users/contacts/${contactEmail}`);
}

export async function inviteContact(contactEmail) {
    return apiPost(`/users/invitations`, { to: contactEmail });
}

export async function updateContact(updatedContact) {
    return apiPatch(`/users/contacts/${updatedContact.email}`, { name: updatedContact.name });
}

export async function getContactPublicKey(contactEmail) {
    return apiGet(`/users/keys/public/${contactEmail}`);
}